import { Operation } from 'slate';
import { cloneDeep } from 'lodash';

export const CUSTOM_OPERATIONS = [
  'add_annotation',
  'remove_annotation',
  'set_annotation',
  'add_metadata',
  'remove_metadata',
  'set_metadata',
];

function applyProperties(element: any, newProperties: any) {
  const changes = Object.entries(newProperties);

  for (const [key, value] of changes) {
    element[key] = value;
  }
  return element;
}

const __isOperation = Operation.isOperation;

Operation.CUSTOM_OPERATIONS = CUSTOM_OPERATIONS;

Operation.isOperation = (op: any): op is Operation => {
  if (CUSTOM_OPERATIONS.includes(op.type)) {
    return true;
  }

  return __isOperation(op);
};

const __inverse = Operation.inverse;
Operation.inverse = (op: Operation): Operation => {
  switch (op.type) {
    case 'add_annotation':
      return {
        type: 'remove_annotation',
        annotation: op.annotation,
      };
    case 'remove_annotation':
      return {
        type: 'add_annotation',
        annotation: op.annotation,
      };
    case 'set_annotation':
      return {
        type: 'set_annotation',
        properties: applyProperties(cloneDeep(op.properties), op.newProperties),
        newProperties: op.properties,
      };
    case 'add_metadata':
      return {
        type: 'remove_metadata',
        metadata: op.metadata,
      };
    case 'remove_metadata':
      return {
        type: 'add_metadata',
        metadata: op.metadata,
      };
    case 'set_metadata':
      return {
        type: 'set_metadata',
        properties: applyProperties(cloneDeep(op.properties), op.newProperties),
        newProperties: op.properties,
      };
  }

  return __inverse(op);
};
